export const NOTIFICATION_COUNT_PATH =
  `/notificationCount/{userId}/count` as const;

export type NotificationCountPath = typeof NOTIFICATION_COUNT_PATH;

export const toNotificationCountPath = (userId: string) => {
  return NOTIFICATION_COUNT_PATH.replace('{userId}', userId);
};
